module.exports = __webpack_public_path__ + "static/media/bell-alarm-alert-svgrepo-com.ab1cb1df.svg";